import type { FilterType } from './types'

export const FILTER_TYPE_TO_LABEL: Record<FilterType, string> = {
  regex: 'Regex',
  word: 'Match word',
  substring: 'Match substring',
}
